import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { globalTheme, combineValues } from '@clds/component-theme';
import { typographyMixin } from '@clds/typography';
import { Icon } from '@cld/icon';
import { depthCss } from '../styledHelpers';
import styleMapping from './styleMapping';
import StyledToggleWrapper from './StyledToggleWrapper';

const selectedCss = css`
  background-color: ${globalTheme.palette.primary};
  color: ${globalTheme.palette.contrastInvert};
  ${Icon} {
    color: ${globalTheme.palette.contrastInvert};
  }
  ${(props) => getTypographyCss(props, true)}
`;

const hoverCss = css`
  :hover {
    background-color: ${combineValues(globalTheme.palette.primary, (bgColor) => rgba(bgColor, 0.06))};
  }
`;

const getTypographyCss = ({ size, ...props }, selected) => typographyMixin(size === 'md' ? 'sm' : 'xs', selected ? 'contrastInvert' : 'regular');

const getCssBySize = ({ size, ...props }) => {
  return css`
    ${getTypographyCss};
    line-height: ${styleMapping[size]};
    height: ${styleMapping[size]};

    ${StyledToggleWrapper} {
      height: ${styleMapping[size]};
    }
  `;
};

const StyledTreeNode = styled.div`
  display: flex;
  padding-left: ${depthCss};
  padding-right: ${globalTheme.spacing.sm};
  align-items: center;
  user-select: none;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  transition: background-color 150ms, color 150ms;
  cursor: pointer;
  font-weight: ${({ depth }) => (depth > 0 ? 'normal' : '500')};
  border-radius: 0 1000px 1000px 0;
  ${getCssBySize}

  ${Icon} {
    transition: fill 150ms;
    fill: currentColor;
    color: ${globalTheme.palette.contrastLow};
  }
  ${(props) => (props.selected ? selectedCss : hoverCss)}
`;

export default StyledTreeNode;
